module.exports = __webpack_public_path__ + "assets/img/img85.6c34b1f6.png";